import theme from '../../theme-dm';

function removePrefix(mediaQuery) {
  if (mediaQuery && mediaQuery.startsWith('@media ')) {
    return mediaQuery.substring(7);
  }
  return mediaQuery;
}

export function getMediaQueryOrder() {
  const horizontalBreakpoints = theme.breakpoints.horizontal;
  const horizontalBreakPointsOrdered = Object.keys(horizontalBreakpoints).map(
    key => {
      const mediaQuery = removePrefix(horizontalBreakpoints[key].mediaQuery);

      return {
        value: horizontalBreakpoints[key].value,
        mediaQuery,
      };
    },
  );
  horizontalBreakPointsOrdered.sort((a, b) => a.value - b.value);
  return horizontalBreakPointsOrdered.map(({ mediaQuery }) => mediaQuery);
}
